const includeInArray = <T>(item: T, shouldInclude: boolean) =>
  shouldInclude ? [item] : [];

export default includeInArray;
